<div class="select-container" [class.disabled]="disabled || isLoading" [style.padding]="padding">
    <div class="select-container-box" (click)="toggleDropdown()">
        <div class="select-container-box-header">
            <span>{{ title }}</span>
            @if (selectionEnabled) {
                <span class="select-container-box-header-selected">{{ selectedLabel | translate }}</span>
            }
        </div>

        @if (isLoading) {
            <span class="select-container-box-icon-loader"></span>
        } @else {
            <svg class="select-container-box-icon" width="21" height="11" viewBox="0 0 21 11" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1.24707 1.11914C0.764439 1.62912 0.798658 2.45424 1.34961 2.91992L9.42773 9.74805L9.54687 9.83984C10.1182 10.2407 10.8818 10.2407 11.4531 9.83984L11.5723 9.74805L19.6543 2.91699C20.2034 2.45269 20.2379 1.63061 19.7578 1.12109L19.6553 1.02344C19.1931 0.632103 18.5154 0.631742 18.0527 1.02246L10.9268 7.04004L10.8301 7.1084C10.6264 7.22559 10.3745 7.22464 10.1709 7.10742L10.0732 7.04004L2.95312 1.02246C2.49069 0.631675 1.81363 0.631425 1.35059 1.02148L1.24707 1.11914Z"
                    fill="#2DADC8" stroke="#2DADC8" />
            </svg>
        }
    </div>

    @if (isOpen) {
    <div class="select-container-options-dropdown" [style.padding]="padding">
        <div class="select-container-options-dropdown-list">
            @for (option of options; track option.value; let index = $index) {
            <div class="select-container-options-dropdown-list-option" [class.selected]="selectionEnabled && option.value === value"
                (click)="selectOption(option)">
                <span>{{ option.label | translate }}</span>

                @if (index === 0) {
                <svg (click)="toggleDropdown(); $event.stopPropagation()" width="21" height="11" viewBox="0 0 21 11"
                    fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M1.24707 1.11914C0.764439 1.62912 0.798658 2.45424 1.34961 2.91992L9.42773 9.74805L9.54687 9.83984C10.1182 10.2407 10.8818 10.2407 11.4531 9.83984L11.5723 9.74805L19.6543 2.91699C20.2034 2.45269 20.2379 1.63061 19.7578 1.12109L19.6553 1.02344C19.1931 0.632103 18.5154 0.631742 18.0527 1.02246L10.9268 7.04004L10.8301 7.1084C10.6264 7.22559 10.3745 7.22464 10.1709 7.10742L10.0732 7.04004L2.95312 1.02246C2.49069 0.631675 1.81363 0.631425 1.35059 1.02148L1.24707 1.11914Z"
                        fill="#2DADC8" stroke="#2DADC8" />
                </svg>
                }
            </div>
            }
        </div>
    </div>
    }
</div>